import {
  TRESPONSE_GET_TNA_STEP_APPROVAL_DETAILS,
  TRESPONSE_GET_TNA_STEP_APPROVAL_LIST,
  TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_DETAILS,
  TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST,
} from '@monorepo/types';
import { TAccordionActionInfo, TAccordionTableVM } from '../../model/accordion-table.types';
import { DateUtils } from '@monorepo/utils';

const ACTION_DISPLAY_CONF: TAccordionActionInfo[] = [
  {
    actionId: 'APPROVED',
    displayName: 'Approve Request',
  },
  {
    actionId: 'DECLINED',
    displayName: 'Decline Request',
  },
];

const STATUS_TAG_CONF = {
  PENDING: {
    displayString: 'Approval Pending',
    color: '#F5BE40',
    icon: 'assets/common/info-icon-white.svg',
  },
  APPROVED: {
    displayString: 'Request Approved',
    color: '#0e8526',
    icon: 'assets/common/info-icon-white.svg',
  },
  DECLINED: {
    displayString: 'Request Declined',
    color: '#E6420B',
    icon: 'assets/common/info-icon-white.svg',
  },
  CANCELLED: {
    displayString: 'Request Cancelled',
    color: '#0069d1',
    icon: 'assets/common/info-icon-white.svg',
  },
};

function _mapToValuesList(stringList: string[] | number[]) {
  return stringList.map((str) => {
    return {
      displayName: str,
    };
  });
}

export const TNA_STEP_APPROVALS_ACCORDION_TABLE_MODEL = {
  createModel(
    tnaStepApprovalsItemList?: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST['tnaOrderStepItemList'],
  ): TAccordionTableVM {
    return {
      headers: [
        { label: 'STEPS', colSize: 9 },
        { label: 'CRITICAL', colSize: 7 },
        { label: 'TARGET DATE', colSize: 7 },
      ],
      accordions: tnaStepApprovalsItemList
        ? tnaStepApprovalsItemList.map((tnaStepApproval) => {
            return {
              id: tnaStepApproval.tosId,
              tag: [
                {
                  displayName: tnaStepApproval.userOrderTnaId,
                  frequency: 1,
                  class: 'accordian-table__tag--data',
                },
              ],
              isMinimized: true,
              rowItems: [
                { type: 'TEXT', value: tnaStepApproval.step },
                { type: 'TEXT', value: tnaStepApproval.isCritical },
                { type: 'TEXT', value: DateUtils.getDisplayDateStringFromDate(tnaStepApproval.targetDate) },
              ],
              moreInfo: [],
              actions: [],
            };
          })
        : [],
    };
  },

  updateModelOnTnaStepApprovalUpdate(
    tnaStepApprovalItem: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST['tnaOrderStepItemList'][number],
    tnaStepApproval: TRESPONSE_GET_TNA_STEP_APPROVAL_DETAILS,
    accordianTable: TAccordionTableVM,
  ): TAccordionTableVM {
    const statustag = tnaStepApproval.tnaOrderStepDetailsDTO.approvalRequestStatus && {
      statusTag: STATUS_TAG_CONF[tnaStepApproval.tnaOrderStepDetailsDTO.approvalRequestStatus],
      //   {
      //     displayString: tnaStepApproval.tnaOrderStepDetailsDTO.approvalRequestStatus,
      //     color: '#F5BE40',
      //     icon: 'assets/common/info-icon-white.svg',
      //   },
    };
    return {
      ...accordianTable,
      accordions: accordianTable.accordions.map((accordian) => {
        if (accordian.id === tnaStepApprovalItem.tosId) {
          return {
            ...accordian,
            isMinimized: false,
            moreInfo: [
              {
                items: [
                  {
                    size: 12,
                    label: 'Responsible Team',
                    values: _mapToValuesList([tnaStepApproval.tnaOrderStepDetailsDTO.responsibleTeam]),
                  },
                  {
                    size: 12,
                    label: 'People in-charge',
                    values: _mapToValuesList(
                      tnaStepApproval.tnaOrderStepDetailsDTO.employees.map(
                        (employee) => `${employee.employeeName} (${employee.employeeId})`,
                      ),
                    ),
                  },
                  {
                    size: 12,
                    label: 'Pre-requisite',
                    values: _mapToValuesList(tnaStepApproval.tnaOrderStepDetailsDTO.preRequisites),
                  },
                  {
                    size: 12,
                    label: 'Completion Date',
                    values: _mapToValuesList(['--']),
                  },
                  {
                    size: 12,
                    label: 'Build allowance',
                    values: _mapToValuesList(
                      tnaStepApproval.tnaOrderStepDetailsDTO.buildAllowance
                        ? [tnaStepApproval.tnaOrderStepDetailsDTO.buildAllowance + ' days']
                        : ['--'],
                    ),
                  },
                ],
              },
              {
                sectionName: 'Order details',
                items: [
                  {
                    size: 12,
                    label: 'Order Id',
                    values: _mapToValuesList([tnaStepApproval.orderDetailsDTO.orderId]),
                  },
                  {
                    size: 12,
                    label: 'Buyer',
                    values: _mapToValuesList([tnaStepApproval.orderDetailsDTO.buyer]),
                    type: 'LOCATION',
                  },
                  {
                    size: 12,
                    label: 'Style',
                    values: _mapToValuesList([tnaStepApproval.orderDetailsDTO.style]),
                  },
                  {
                    size: 12,
                    label: 'Product Type',
                    values: _mapToValuesList(tnaStepApproval.orderDetailsDTO.productTypes),
                  },
                  {
                    size: 12,
                    label: 'Earlier Delivery Date',
                    values: _mapToValuesList([
                      DateUtils.getDisplayDateStringFromDate(tnaStepApproval.orderDetailsDTO.minDeliveryDate),
                    ]),
                  },
                  {
                    size: 12,
                    label: 'Latest Delivery Date',
                    values: _mapToValuesList([
                      DateUtils.getDisplayDateStringFromDate(tnaStepApproval.orderDetailsDTO.maxDeliveryDate),
                    ]),
                  },
                  {
                    size: 12,
                    label: 'Season',
                    values: _mapToValuesList([tnaStepApproval.orderDetailsDTO.season]),
                  },
                ],
              },
            ],
            editableInfo: [
              {
                items: [
                  {
                    size: 12,
                    label: 'Add Expected Date',
                    icon: 'assets/common/edit.svg',
                    actionDislayName: 'Add Expected Date',
                    actionId: 'ADD_UPDATE_EXPECTED_DATE',
                    value: tnaStepApproval.tnaOrderStepDetailsDTO.expectedDate
                      ? tnaStepApproval.tnaOrderStepDetailsDTO.expectedDate
                      : undefined,
                    ...statustag,
                  },
                ],
                actions: [],
              },
            ],
          };
        } else {
          return accordian;
        }
      }),
    };
  },

  resetTnaStepInModel(
    accordianTable: TAccordionTableVM,
    tosId: TRESPONSE_GET_TNA_STEP_APPROVAL_LIST['tnaOrderStepItemList'][number]['tosId'],
  ): TAccordionTableVM {
    return {
      ...accordianTable,
      accordions: accordianTable.accordions.map((accordian) => {
        if (accordian.id === tosId) {
          return {
            ...accordian,
            moreInfo: [],
          };
        } else {
          return accordian;
        }
      }),
    };
  },
};

export const TNA_STEP_APPROVALS_PENDING_ACCORDION_TABLE_MODEL = {
  createModel(
    tnaStepApprovalsPendingItemList?: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST['stepApprovalPendingItems'],
  ): TAccordionTableVM {
    return {
      headers: [
        { label: 'APPROVAL TYPE', colSize: 9 },
        { label: 'ORDER ID', colSize: 7 },
        { label: 'TARGET DATE', colSize: 7 },
      ],
      accordions: tnaStepApprovalsPendingItemList
        ? tnaStepApprovalsPendingItemList.map((tnaStepApprovalPending) => {
            return {
              id: tnaStepApprovalPending.tnaStepApprovalId,
              tag: [
                {
                  displayName: tnaStepApprovalPending.userOrderTnaId,
                  frequency: 1,
                  class: 'accordian-table__tag--data',
                },
              ],
              isMinimized: true,
              rowItems: [
                { type: 'TEXT', value: tnaStepApprovalPending.tnaStep },
                { type: 'TEXT', value: tnaStepApprovalPending.userOrderTnaId },
                { type: 'TEXT', value: DateUtils.getDisplayDateStringFromDate(tnaStepApprovalPending.targetDate) },
              ],
              moreInfo: [],
              actions: ACTION_DISPLAY_CONF,
            };
          })
        : [],
    };
  },

  updateModelOnTnaStepApprovalUpdate(
    tnaStepApprovalPendingItem: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST['stepApprovalPendingItems'][number],
    tnaStepApprovalPending: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_DETAILS,
    accordianTable: TAccordionTableVM,
  ): TAccordionTableVM {
    return {
      ...accordianTable,
      accordions: accordianTable.accordions.map((accordian) => {
        if (accordian.id === tnaStepApprovalPendingItem.tnaStepApprovalId) {
          return {
            ...accordian,
            isMinimized: false,
            moreInfo: [
              {
                items: [
                  {
                    size: 12,
                    label: 'Responsible Team',
                    values: _mapToValuesList([tnaStepApprovalPending.tnaOrderStepDetailsDTO.responsibleTeam]),
                  },
                  {
                    size: 12,
                    label: 'People in-charge',
                    values: _mapToValuesList(
                      tnaStepApprovalPending.tnaOrderStepDetailsDTO.employees.map(
                        (employee) => `${employee.employeeName} (${employee.employeeId})`,
                      ),
                    ),
                  },
                  {
                    size: 12,
                    label: 'Pre-requisite',
                    values: _mapToValuesList(tnaStepApprovalPending.tnaOrderStepDetailsDTO.preRequisites),
                  },
                  {
                    size: 12,
                    label: 'Completion Date',
                    values: _mapToValuesList(['--']),
                  },
                  {
                    size: 12,
                    label: 'Build allowance',
                    values: _mapToValuesList(
                      tnaStepApprovalPending.tnaOrderStepDetailsDTO.buildAllowance
                        ? [tnaStepApprovalPending.tnaOrderStepDetailsDTO.buildAllowance + ' days']
                        : ['--'],
                    ),
                  },
                ],
              },
              {
                sectionName: 'Order details',
                items: [
                  {
                    size: 12,
                    label: 'Order Id',
                    values: _mapToValuesList([tnaStepApprovalPending.orderDetailsDTO.orderId]),
                  },
                  {
                    size: 12,
                    label: 'PO',
                    values: _mapToValuesList([tnaStepApprovalPending.orderDetailsDTO.po]),
                  },
                  {
                    size: 12,
                    label: 'Buyer',
                    values: _mapToValuesList([tnaStepApprovalPending.orderDetailsDTO.buyer]),
                    type: 'LOCATION',
                  },
                  {
                    size: 12,
                    label: 'Earlier Delivery Date',
                    values: _mapToValuesList([
                      DateUtils.getDisplayDateStringFromDate(tnaStepApprovalPending.orderDetailsDTO.minDeliveryDate),
                    ]),
                  },
                  {
                    size: 12,
                    label: 'Style',
                    values: _mapToValuesList([tnaStepApprovalPending.orderDetailsDTO.style]),
                  },
                  {
                    size: 12,
                    label: 'Latest Delivery Date',
                    values: _mapToValuesList([
                      DateUtils.getDisplayDateStringFromDate(tnaStepApprovalPending.orderDetailsDTO.maxDeliveryDate),
                    ]),
                  },
                  {
                    size: 12,
                    label: 'Product Type',
                    values: _mapToValuesList(tnaStepApprovalPending.orderDetailsDTO.productTypes),
                  },
                  {
                    size: 12,
                    label: 'Season',
                    values: _mapToValuesList([tnaStepApprovalPending.orderDetailsDTO.season]),
                  },
                  {
                    size: 12,
                    label: 'Requested By',
                    values: _mapToValuesList([tnaStepApprovalPending.updateRequestInfo.requestedBy]),
                  },
                  {
                    size: 12,
                    label: 'Expected Date',
                    values: _mapToValuesList(
                      tnaStepApprovalPending.tnaOrderStepDetailsDTO.expectedDate
                        ? [
                            DateUtils.getDisplayDateStringFromDate(
                              tnaStepApprovalPending.tnaOrderStepDetailsDTO.expectedDate,
                            ),
                          ]
                        : [],
                    ),
                  },
                ],
              },
            ],
            actions: accordian.actions,
          };
        } else {
          return accordian;
        }
      }),
    };
  },

  resetTnaStepInModel(
    accordianTable: TAccordionTableVM,
    approvalId: TRESPONSE_GET_TNA_STEP_APPROVAL_PENDING_LIST['stepApprovalPendingItems'][number]['tnaStepApprovalId'],
  ): TAccordionTableVM {
    return {
      ...accordianTable,
      accordions: accordianTable.accordions.map((accordian) => {
        if (accordian.id === approvalId) {
          return {
            ...accordian,
            moreInfo: [],
          };
        } else {
          return accordian;
        }
      }),
    };
  },
};
